import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import withDefaultProps from 'helpers/withDefaultProps';

const ConditionalSpinner = ({ showSpinner, children, ...props }) =>
  showSpinner ? (
    <Spinner
      as="span"
      animation="border"
      size="sm"
      role="status"
      aria-hidden="true"
      className="mr-2"
      {...props}
    />
  ) : (
    children
  );

ConditionalSpinner.propTypes = {
  showSpinner: PropTypes.bool.isRequired,
  ...withDefaultProps(),
};

export default ConditionalSpinner;
